import { CourseLoaderConfig } from "./types";

/**
 * Initializes and loads courses for the organization
 * @param config Configuration object with organization details
 */
export async function initializeCourseLoader(
    config: CourseLoaderConfig,
): Promise<void> {
    setDefaultOrganizationLogo(config);
    await handleCourses(config);
}

/**
 * Sets the default organization logo from data attributes
 */
function setDefaultOrganizationLogo(config: CourseLoaderConfig): void {
    const $logoElement = $(`#${config.organizationLogoCellId}`);
    const defaultLogo = $logoElement.data(config.organizationLogoDataAttribute);

    if (defaultLogo) {
        $(".js-no-org-image").attr("src", defaultLogo);
    }
}

/**
 * Handles loading provided and upcoming courses
 */
async function handleCourses(config: CourseLoaderConfig): Promise<void> {
    const { organizationId, courseLandingPage } = config;

    await loadProvidedCourses(organizationId, courseLandingPage);
    await loadUpcomingCourses(organizationId, courseLandingPage);
}

/**
 * Loads courses provided by the organization
 */
async function loadProvidedCourses(
    organizationId: string,
    courseLandingPage: string,
): Promise<void> {
    const container = $("#orgCoursesProvidedPartial");

    return $.ajax({
        type: "POST",
        url: `/api/TrainerSearch/LoadCoursesProvided?organizationId=${organizationId}`,
        success: function (data: string) {
            container.removeClass("d-none");
            SaSpinnerUtils.HideSectionSpinner("#spinnerProvided");

            if (data.trim().length > 0) {
                container.html(data);

                // Update course links with landing page URL
                $(".js-course-provided-link").each(function (
                    this: HTMLElement,
                ) {
                    const $link = $(this);
                    const href = $link.data("href");
                    $link.attr("href", courseLandingPage + href);
                });

                // Show search available courses section
                $("#searchAvailableCourses")
                    .removeClass("d-none")
                    .addClass("d-lg-flex");
            }
        },
        error: function () {
            container.html(
                `<p class="text-center saFgColorNeutral600">Courses could not be loaded.</p>`,
            );
        },
    });
}

/**
 * Loads upcoming courses for the organization
 */
async function loadUpcomingCourses(
    organizationId: string,
    courseLandingPage: string,
): Promise<void> {
    const container = $("#orgCoursesUpcomingPartial");

    return $.ajax({
        type: "POST",
        url: `/api/TrainerSearch/LoadCoursesUpcoming?organizationId=${organizationId}`,
        success: function (data: string) {
            container.removeClass("d-none");
            SaSpinnerUtils.HideSectionSpinner("#spinnerUpcoming");

            if (data.trim().length > 0) {
                container.html(data);

                // Update text content from data attributes
                const upcomingCoursesLocationHeaderText = container.data(
                    "upcomingcourseslocationheadertext",
                );
                const registerText = container.data("register");
                const learnText = container.data("learn");

                $(".js-upcomingcourseslocationheadertext").text(
                    upcomingCoursesLocationHeaderText,
                );
                $(".js-register").text(registerText);
                $(".js-learn").text(learnText);

                // Update course links with landing page URL
                $(".js-course-upcoming-link").each(function (
                    this: HTMLElement,
                ) {
                    const $link = $(this);
                    const href = $link.data("href");
                    $link.attr("href", courseLandingPage + href);
                });

                // Show find a course link
                $("#showFindACourseLink").removeClass("d-none");
            }
        },
        error: function () {
            container.html(
                `<p class="text-center saFgColorNeutral600">Upcoming courses could not be loaded.</p>`,
            );
        },
    });
}
